import { ReactNode } from "react";
import MinMaxSelect from "../../../../search-filter-options/MinMaxSelects/MinMaxSelects";

interface PriceOptionProps {
  min: number | undefined;
  max: number | undefined;
  onChange: (min?: number, max?: number) => void;
  className?: string;
  labelAction?: ReactNode;
}

const prices: number[] = [];

for (let v = 25_000; v <= 500_000; v += 25_000) {
  prices.push(v);
}

for (let v = 550_000; v < 1_000_000; v += 50_000) {
  prices.push(v);
}

for (let v = 1_000_000; v <= 5_000_000; v += 250_000) {
  prices.push(v);
}

for (let v = 6_000_000; v <= 10_000_000; v += 1_000_000) {
  prices.push(v);
}

// Shared by the fixed options and the off-grid formatValue so an AI-applied
// price (e.g. 825000) renders the same style of label as the dropdown.
const formatPrice = (v: number) =>
  v >= 1_000_000 ? `$${(v / 1_000_000).toFixed(v % 1_000_000 === 0 ? 0 : 2)}M` : `$${v / 1000}K`;

const priceOptions = prices.map((v) => ({
  value: v,
  label: formatPrice(v),
}));

export default function PriceOption({
  min,
  max,
  onChange,
  className,
  labelAction,
}: PriceOptionProps) {
  return (
    <MinMaxSelect
      groupLabel="Price Range"
      labelAction={labelAction}
      // minLabel={"Min. Price"}
      // maxLabel={"Max. Price"}
      minValue={min}
      maxValue={max}
      onChange={onChange}
      options={priceOptions}
      formatValue={formatPrice}
    />
  );
}
